import { render, staticRenderFns } from "./CompilationsFolders.vue?vue&type=template&id=84ea561a&scoped=true"
import script from "./CompilationsFolders.vue?vue&type=script&lang=js"
export * from "./CompilationsFolders.vue?vue&type=script&lang=js"
import style0 from "./CompilationsFolders.vue?vue&type=style&index=0&id=84ea561a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ea561a",
  null
  
)

export default component.exports